<div class="gender-wrapper">
  <div class="gender">

    <h2>{{"Discover by Gender"|translate}}</h2>

    @for (subCat of rule!.subCategories; let i = $index; track $index) {
    <button class="btn btn-link" (click)="selectedGender.set(i)" [class.active]="selectedGender() === i">
      <div class="img-wrapper">
        <app-asset [assetId]="subCat.assetId"></app-asset>
      </div>
      {{subCat.name}}
    </button>
    }

  </div>
</div>

<app-category-body [categories]="category()"></app-category-body>
